export default "__VITE_ASSET__uVydTZhT__"